
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface TitleFieldProps {
  title: string;
  onTitleChange: (value: string) => void;
}

export function TitleField({
  title,
  onTitleChange
}: TitleFieldProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor="title">Title</Label>
      <Input
        id="title"
        placeholder="Enter assessment title"
        value={title}
        onChange={(e) => onTitleChange(e.target.value)}
        required
      />
    </div>
  );
}
